export const contractTypeOptions = [
  { value: "ONE_MONTH", label: "One Month" },
  { value: "THREE_MONTHS", label: "Quarter" },
  { value: "SIX_MONTHS", label: "Six Months" },
  { value: "TWELVE_MONTHS", label: "One Year" },
  { value: "PERMANENT", label: "Permanent" },
];
export const paymentTypeOptions = [
  { value: "bank", label: "Bank Transfer" },
  { value: "cash", label: "Cash" },
];
export const ownershipTypeOptions = [
  { value: "sold", label: "Sold" },
  { value: "rent", label: "Rent" },
];
